import { Box } from "@stenajs-webui/core";
import { FlatButton, stenaInfoCircle } from "@stenajs-webui/elements";
import { Popover } from "@stenajs-webui/tooltip";
import * as React from "react";
import { InfoBoxItem } from "../InfoBoxItem";
import { CustomerBox } from "../types";
import { formatDateStringWithLocalTimeZone } from "@/lib/dates/formatters";
import { ZIndex } from "@/lib/utils/ZIndexEnum";

interface Props {
  customer: CustomerBox;
}

export const CustomerInfoPairPopover: React.FC<Props> = ({ customer }) => {
  const custNameUpperCase = customer.name?.toUpperCase() ?? "";
  const custStatusUpperCase = customer.custStatus?.name?.toUpperCase() ?? "";

  return (
    <Popover
      zIndex={ZIndex.high}
      placement={"right"}
      trigger={"click"}
      renderTrigger={(props) => (
        <Box width={16}>
          <FlatButton leftIcon={stenaInfoCircle} {...props} />
        </Box>
      )}
      disablePadding
      appendTo={document.body}
    >
      <Box indent={2} spacing={1}>
        <InfoBoxItem
          leftContent={"Name"}
          rightContent={custNameUpperCase}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Status"}
          rightContent={custStatusUpperCase}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Rebate"}
          rightContent={customer.hasRebateAgreements ? "Yes" : "No"}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Seller"}
          rightContent={customer.seller.name}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Sales region"}
          rightContent={customer.salesRegion.name}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created"}
          rightContent={
            formatDateStringWithLocalTimeZone({
              dateString: customer.writeHistory.createdAt.isoString,
              options: {
                dateStyle: "short",
                timeStyle: "short",
              },
            }) ?? ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Created by"}
          rightContent={customer.writeHistory.createdBy.name ?? ""}
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified"}
          rightContent={
            (customer.writeHistory.modifiedAt?.isoString &&
              formatDateStringWithLocalTimeZone({
                dateString: customer.writeHistory.modifiedAt?.isoString,
                options: {
                  dateStyle: "short",
                  timeStyle: "short",
                },
              })) ??
            ""
          }
          popoverEnabled
        />
        <InfoBoxItem
          leftContent={"Modified by"}
          rightContent={customer.writeHistory.modifiedBy?.name ?? ""}
          popoverEnabled
        />
      </Box>
    </Popover>
  );
};
